module.exports = __webpack_public_path__ + "media/images/svg-icon/close-27cc5d0053bf0efb28fd03f064c9a007.svg";